import React from "react";
import { Modal, Paper, Box } from "@mui/material";
import PurpleButton from "./PurpleButton"; 

const BaseModal = ({ open, onClose, children, modalStyle }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box>
        <Paper sx={modalStyle}>
          {children}
          <Box mt={2} display="flex" justifyContent="flex-end">
            <PurpleButton onClick={onClose} label="Close" />
          </Box>
        </Paper>
      </Box>
    </Modal>
  );
};

export default BaseModal;
